import type {
  ErrorRouteComponent,
  NotFoundRouteComponent,
} from '@tanstack/react-router';
import { useRouter } from '@tanstack/react-router';
import { useTranslate } from '@tolgee/react';
import { ErrorTranslationKey } from '~/model/ErrorTranslationKey';

export function DefaultErrorComponent(props: Props) {
  const { t } = useTranslate();

  const router = useRouter();

  function reset() {
    const anyProps = props as any;

    if (anyProps.reset) {
      anyProps.reset();
    } else {
      location.reload();
    }

    router.invalidate();
  }

  let errorName = props.error?.name || '';
  const errorMessage = props.error?.message || '';

  switch (errorMessage) {
    case ErrorTranslationKey.ErrorForbidden:
      errorName = 'error_forbidden_title';
      break;
  }

  return (
    <div className="h-full bg-red-100 drop-shadow-md rounded-xl block p-3 md:p-8 border-red-600 border-2">
      <div className="flex flex-col gap-4">
        {errorName ? (
          <h2 className="text-xl font-bold">{t(errorName)}</h2>
        ) : null}
        {errorMessage ? <p>{t(errorMessage)}</p> : null}
        <div>
          <button
            className="px-4 py-2 rounded-xl shadow dark:shadow-gray-900/50 bg-red-600 hover:bg-red-800 cursor-pointer text-white"
            onClick={reset}
          >
            {t('error_reload_label')}
          </button>
        </div>
      </div>
    </div>
  );
}

type Props = (
  | Parameters<ErrorRouteComponent>[0]
  | Parameters<NotFoundRouteComponent>[0]
) & {
  readonly error?: Error | any;
};
